import {Injectable, Injector} from '@angular/core';
import {ApiResponse, BaseApiService} from '../base-api.service';
import {LocalsModelService} from '../../Models/Core/locals-model.service';
import {LocalFamiliesModelService} from '../../Models/Core/local-families-model.service';
import {LocalDto} from '../../../Models/Local/local.interface';
import {PermissionsManagerService} from '../../Shared/permissions-manager.service';
import {FranchiseesApiService} from './franchisees-api.service';

@Injectable({
  providedIn: 'root'
})
export class LocalsApiService extends BaseApiService {

  constructor(
    protected override injector: Injector,
    protected permissionsManager: PermissionsManagerService,
    protected franchiseesService: FranchiseesApiService,
    public model: LocalsModelService,
    public modelLocalFamilies: LocalFamiliesModelService,
  ) {
    super(injector);
  }


  /**
   * Obtener los locales
   *
   */
  public getLocals(all: number = 0, save: boolean = true): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('getLocales', {all}, 'get').subscribe({
        next: (response) => {
          if (save) {
            this.model.save(response.data);
          }

          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Obtener las familias de los locales
   *
   */
  public getLocalFamilies(save: boolean = true): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('getFamiliasWithLocales', {filtro_usuario: true}).subscribe({
        next: (response) => {
          if (save) {
            this.modelLocalFamilies.save(response.data);
          }

          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Obtener los franquiciados y los locales
   *
   */
  async getFranchiseeAndLocals(permission?: string): Promise<LocalDto[]> {
    const locals = (await this.model.list()) || [];
    const franchisees = (await this.franchiseesService.model.list()) || [];

    if (permission && !this.permissionsManager.checkPermission(permission, 'ver')) {
      return locals;
    }

    return [...locals, ...franchisees];
  }

}
